"use client";

import { faCartPlus } from "@fortawesome/pro-solid-svg-icons";
import { Button, NativeInput } from "@tosize/ui";
import { type ReactNode, useState } from "react";
import type { AddToCartMessagesType } from "~/app/[lang]/cart/utils/getAddToCartMessages";
import { useAddToCart } from "~/app/[lang]/cart/utils/useAddToCart";
import type { LangParams } from "~/app/[lang]/layout";
import ButtonGroup from "~/components/utilities/ButtonGroup";

interface Props extends LangParams {
	children: ReactNode;
	cartMessages: AddToCartMessagesType;
	id: string;
}

export function AddToCartButton({ lang, cartMessages, id, children }: Props) {
	const { handleAddItem, addingItem } = useAddToCart(cartMessages);

	return (
		<Button
			className="!rounded-full"
			starticon={faCartPlus}
			color="success"
			isLoading={addingItem}
			onClick={async () => await handleAddItem({ lang, cartItem: { id: id, quantity: 1 } })}
		>
			{children}
		</Button>
	);
}

export function AddToCartButtonWithQuantity(props: Props & { label: string }) {
	const { cartMessages, id, label, lang, children } = props;
	const { handleAddItem, addingItem } = useAddToCart(cartMessages);
	const [quantity, setQuantity] = useState(1);

	return (
		<ButtonGroup>
			<NativeInput
				type="number"
				aria-label={label}
				placeholder={label}
				className="max-w-[6rem]"
				value={quantity}
				onChange={(e) => setQuantity(Number(e.target.value))}
			/>
			<Button
				starticon={faCartPlus}
				color="success"
				size="large"
				className="w-full"
				isLoading={addingItem}
				onClick={async () => await handleAddItem({ lang, cartItem: { id: id, quantity } })}
			>
				{children}
			</Button>
		</ButtonGroup>
	);
}
